<template>
  <div class="d-flex flex-column justify-center dimensions-100">
    <p class="error-page-403">403</p>
    <p class="dark-purple-text font-weight-bold display-1 text-align-center">
      Access Denied
    </p>
    <h2 class="text-align-center dark-purple-text">
      You don't have permission to access this resource
    </h2>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.error-page-403 {
  color: #edebf9;
  font-size: 10em;
  font-weight: 900;
  text-align: center;
}
.text-align-center {
  text-align: center;
}
.dimensions-100 {
  height: 100vh;
  width: 100vw;
}
</style>